import { useContext } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { FaArrowRotateRight } from 'react-icons/fa6';

import useServer from '../../../api/useServerMain';
import InputDuration from '../../../components/forms/InputDuration';
import TextArea from '../../../components/forms/TextArea';
import Button from '../../../components/misc/Button';
import { durationTimeToMinutes, minutesToDurationTime } from '../../../utils/helpers';
import { DetailProductContext } from '../DetailProductContainer';

const ProcessedGeneral = () => {
  const { denyRoles } = useServer()

  const { product, updateProduct } = useContext(DetailProductContext)

  const { handleSubmit, control } = useForm()

  const onSubmit: SubmitHandler<Record<string, any>> = (data) => {
    const { elaborationSteps, averagePreparationTime } = data

    const dataToSend = {
      elaborationSteps,
      averagePreparationTime: durationTimeToMinutes(averagePreparationTime),
    }
    updateProduct!(product?.id, dataToSend)
  }

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className="grid grid-cols-1 place-content-between"
    >
      <div className="flex h-auto flex-col items-start justify-start gap-2 rounded-md border border-slate-300 p-7">
        <InputDuration
          name={'averagePreparationTime'}
          label={'Tiempo de preparación (HH:MM)'}
          control={control}
          defaultValue={minutesToDurationTime(
            product?.averagePreparationTime ?? 0
          )}
        />
        <div className="w-full">
          <TextArea
            name="elaborationSteps"
            control={control}
            defaultValue={product?.elaborationSteps}
            label="Pasos de elaboración"
            textareaClassName={'h-[40dvh]'}
          />
        </div>
      </div>

      <div className="flex justify-end py-4">
        {denyRoles(['AUDITOR']) && (
          <Button
            icon={<FaArrowRotateRight className={`h-5`} />}
            name="Actualizar"
            color="slate-600"
            type="submit"
          />
        )}
      </div>
    </form>
  )
}

export default ProcessedGeneral
